export const STATE = 'story'

export const SET_STEP_1 = `${STATE}/SET_STEP_1`
export const SET_STEP_2 = `${STATE}/SET_STEP_2`
export const SET_STEP_3 = `${STATE}/SET_STEP_3`
export const SET_STEP_4 = `${STATE}/SET_STEP_4`
export const SET_STEP_5 = `${STATE}/SET_STEP_5`
